export const API_BASE_URL = `${import.meta.env.VITE_API_BASE_URL}/api`
export const ODOO_BASE_URL = `${import.meta.env.VITE_API_ODOO_BASE_URL}/api`

export const GET_PATIENTS = '/patient'
export const REGISTER_PATIENT = '/patient/registrations'

// Vists endpoints
export const GET_DEPARTMENTS = '/master-data/departments'
export const GET_B2B_PARTNERS = '/master-data/b2b'
export const GET_B2B_PARTNER_BY_ID = (id: string) => `/master-data/b2b/${id}`
export const UPDATE_B2B_PARTNER_STATUS = (id: string) =>
  `/master-data/b2b/${id}/status`
export const SEARCH_B2B_PARTNERS = '/master-data/b2b/search'

// Wards endpoints
export const GET_WARDS = 'master-data/wards'
export const GET_WARD_BY_ID = (id: string) => `/master-data/wards/${id}`
export const UPDATE_WARD_STATUS = (id: string) =>
  `/master-data/wards/${id}/status`
export const SEARCH_WARDS = '/master-data/wards/search'

// Rooms endpoints
export const GET_ROOMS = '/master-data/rooms/search'
export const CREATE_ROOM = '/master-data/rooms'
export const GET_ROOM_BY_ID = (id: string) => `/master-data/rooms/${id}`
export const UPDATE_ROOM_STATUS = (id: string) =>
  `/master-data/rooms/${id}/status`
export const SEARCH_ROOMS = '/master-data/rooms/search'
export const GET_ACTIVE_ROOMS_BY_WARD = (wardId: string) =>
  `/master-data/wards/${wardId}/rooms/active`

// Beds endpoints
export const GET_BEDS = '/master-data/beds/search'
export const GET_BEDS_ALL_DATA = '/master-data/beds/all-data'
export const GET_BED_BY_ID = (id: string) => `/master-data/beds/${id}`
export const UPDATE_BED_STATUS = (id: string) =>
  `/master-data/beds/${id}/current-status`
export const SEARCH_BEDS = '/master-data/beds/search'

export const GET_UNITS = '/master-data/units/getByCode/'
export const GET_CONSULTATION_DOCTORS = '/v1/partners?category_code=DOC'
export const GET_CONSULTATION_NURSE = '/v1/partners?category_code=NRS'
export const GET_RATE_PLANS = '/v1/pricelists'
export const CREATE_VISIT = '/opd/visits'
export const CONSULTATION_FEES = '/v1/prices'
export const GET_VISITS_WITH_BEDS = 'opd/visits/listWithBeds?'

export const GET_HISTORY_EXAMINATION = '/history-examination'
export const CREATE_HISTORY_EXAMINATION = '/opd/history-examination'

export const GET_SPONSER_INFO = '/master-data/sponsors'
export const GET_PATIENT_CATEGORY = 'master-data/patient-categories'
export const GET_REFERRAL_SOURCES = 'master-data/referral-sources'
export const GET_CAMPS = 'master-data/camps'
export const GET_ALL_MASTER_DATA = 'master-data/all'
export const GET_CITIES = 'master-data/locations/city/'
export const GET_MEDICINES = '/v1/products?name='
export const GET_UOMS = '/v1/product_uoms'
export const GET_MEDICINES_SEARCH = (name: string, locationId: number) =>
  `/v1/products?name=${name}&location_id=${locationId}`
export const GET_MASTER_DOCTORS = 'master-data/doctors/get-all-doctors'
export const CHANGE_BED_STATUS = (bedId: any) =>
  `/master-data/beds/${bedId}/status`
export const GET_ALL_VISIT_DATA = (visitId: string) =>
  `/opd/visits/${visitId}/full`
export const GET_VISIT_DATA = (visitId: string) =>
  `/opd/visits/${visitId}?withBeds=true`
export const GET_INVOICE_PDF = (invoiceId: number) =>
  `/v1/invoices/${invoiceId}/pdf`
export const GET_INVOICE_JOURNALS = '/v1/invoices/journals'
export const PAY_INVOICE = (invoiceId: number) =>
  `/v1/invoices/${invoiceId}/pay`
export const PAY_VISIT = (visitId: string) =>
  `/opd/visits/${visitId}/make-payment`
export const PAY_VISIT_BY_INVOICEID = (
  visitId: string,
  visitType: string,
  inVoiceId: number
) => `/billing/visits/${visitId}/${visitType}/invoices/${inVoiceId}/pay`
export const OPEN_BILLS = (page: number, size: number, ref: string) =>
  `/v1/invoices?minimal=true&page=${page}&page_size=${size}&partner_ref=${ref}&sort_by=create_date&
sort_order=desc`
export const GET_PRICES = 'v1/prices'
export const POST_INVOICE = (id: number) => `v1/invoices/${id}/post`
export const CREATE_LINE_ITEMS = '/v1/invoices'
export const UPDATE_LIINE_ITEMS = (id: number) => `/v1/invoices/${id}`
export const GET_LINE_ITEMS = (id: number) => `/v1/invoices?id=${id}`
export const GET_DISC_AUTH = '/v1/partners?category_code=DISC'
export const OPD_VISITS = '/opd/visits'
export const OPD_VISIT_BY_ID = (visitId: string) => `/opd/visits/${visitId}`
export const UTILS_VISIT_BY_ID = (visitId: string) => `/utils/visits/${visitId}`
export const MASTER_VISIT_BY_ID = (visitId: string) =>
  `/master-data/visits/${visitId}`

export const PRESCRIPTIONS = 'investigations-prescription'
export const TRIAGE = 'triage'
export const INITIAL_ASSESSMENT = 'initial-assessment'
export const DIAGNOSIS = 'diagnosis'
export const TREATMENT_PLAN = 'treatment'
export const VITALS = 'vitals'
export const HISTORY_EXAMINATION = 'history-exam'

export const GET_UNIDENTIFIED_PATIENT_DATA = '/patient/uip/reserve'

// export const GET_DIAGNOSIS = '/diagnosis'
// export const CREATE_DIAGNOSIS = '/opd/diagnosis'

// export const GET_TREATMENT_PLAN = '/treatment-plan'
// export const CREATE_TREATMENT_PLAN = '/opd/treatment-plan'

export const GET_INVOICES = '/v1/invoices'

export const METHOD_TYPES_ENDPOINT = '/lms/parameter-methods'
export const SAMPLE_TYPES_ENDPOINT = '/lms/sample-types'
export const LAB_DEPARTMENTS_ENDPOINT = '/lms/lab-departments'
export const UNIT_TYPES_ENDPOINT = '/lms/parameter-unit-types'
export const RESULT_TYPES_ENDPOINT = '/lms/parameter-result-types'
export const LAB_PARAMETERS_ENDPOINT = '/lms/parameters'
export const LAB_PARAMETER_RANGES_ENDPOINT = '/lms/parameter-result-limits'
export const LAB_TESTS_ENDPOINT = '/lms/lab-tests'
export const LAB_PANELS_ENDPOINT = '/lms/panels'
export const LAB_ORDERS_ENDPOINT = '/lms/lab-orders'
export const LAB_ORDER_EVENTS_ENDPOINT = '/lms/lab-order-events'
export const LAB_ORDER_ITEMS_ENDPOINT = '/lms/lab-order-items'
export const LAB_DOCUMENT_DOWNLOAD_ENDPOINT = 'utils/documents/download/'

export const EMERGENCY_DOCTOR_VISITS_ENDPOINT = '/opd/visits'

export const DOCTOR_NOTES = 'doctor-notes'

export const CREATE_CHILD_VISIT = 'opd/visits/child'
export const ALLOCATE_BED = 'opd/visits/'
export const NURSE_NOTES = 'nurse-notes'
export const WARDS = 'master-data/wards'
export const ROOMS_OR_BEDS = 'master-data/wards'

// Visit File/Document endpoints
export const UPLOAD_DOCUMENT = '/utils/upload-document'
export const GET_DOCUMENTS = '/utils/documents'
export const DOWNLOAD_DOCUMENT = '/utils/documents/download'
export const DELETE_DOCUMENT = (documentId: number | string) =>
  `/utils/documents/${documentId}`
export const GET_PROFILE_PICTURE = '/utils/profile-picture'

// Ipd Visit Endpoints
export const CREATE_IPD_VISIT = '/ipd/admissions'
export const GET_IPD_VISITS_WITH_BEDS = 'ipd/visits/listWithBeds?'
export const GET_IPD_VISIT_DATA = (visitId: string) => `/ipd/visit/${visitId}`

// Discharge Summary Endpoints
export const GET_DISCHARGE_SUMMARY = (visitType: any, visitId: any) =>
  `utils/discharges/clinical?visitType=${visitType}&visitId=${visitId}`

export const CREATE_DISCHARGE_SUMMARY = 'utils/discharges/clinical/save'
export const SUBMIT_DISCHARGE_SUMMARY = 'utils/discharges/clinical/submit'

export const ADMIN_MASTER_DATA_ROLES = '/master-data/admin/roles'

export const PATIENT_INDENT_CRETAE = '/stock_request/create'
export const PATIENT_RETURN_INDENT_CRETAE = '/stock_return_request/create'
export const PATIENT_INDENT_GET = '/utils/indent/search'
export const INDENT_STORE_LIST_GET = '/v1/get_internal_locations'
